let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("xCQYl")).then(() => parcelRequire('bgMfn'));